import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ChangedAllSelectionInterface, DataControlMapInterface, DrawAllMapInterface, MarketUnitInterface, MarketPoiInterface, MarketGeofenceInterface, MarketRouteInterface, MarketServiceInterface } from '../models/models.interface';

import Swal from 'ngx-angular8-sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class InterfacectrlmapService {
  private DrawData = new Subject<any>();
  private ZoomData = new Subject<any>();
  private DrawAllData = new Subject<any>();

  public Vehicles: MarketUnitInterface[] = [];
  public POI: MarketPoiInterface[] = [];
  public Geofence: MarketGeofenceInterface[] = [];
  public Route: MarketRouteInterface[] = [];
  public ActiveTracks: boolean = false;
  public Service: MarketServiceInterface[] = [];
  public ActiveServices: boolean = false;  
  constructor(
  ) { }
  //Utils
  GetDataBy(data: boolean[]): string {
    let result = [];
    data.forEach(function (element, index, array) {
      if (element) {
        result.push(index);
      }
    });
    return result.join(';');
  }
  ChangeAll(data: any, value: boolean) {
    data.forEach(function (element, index, array) {
      let result = value;      
      if(element.IsDelete != undefined){
        if(element.IsDelete == true){      
          result = false;  
        }
      }
      data[index].puted = result;
    });
    return data
  }
  ValidAll(data: any): boolean {
    let result = true;
    data.forEach(function (element, index, array) {
      if (!element) {
        result = false;
      }
    });
    return result;
  }
  GetIds(data: any, localStorage: string): boolean[] {
    let result = [];
    data.forEach(function (element, index, array) {
      result[element.Id] = false;
    });

    localStorage.split(';').forEach(function (element, index, array) {
      result[element] = true;
    });
    return result;
  }

  GetDataToMap(_typeObject: number, id: number[], _put: boolean, _remove: boolean): DataControlMapInterface {
    return {
      typeObject: _typeObject,
      ids: id,
      put: _put,
      remove: _remove
    };

  }

  ShowLoading(_title: string = '', _text: string = '') {
    Swal.fire({
      icon: 'info',
      title: _title,
      text: _text,
      allowOutsideClick: false,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      }
    });
    Swal.showLoading();
  }

  HideLoading() {
    setTimeout(() => {
      Swal.close();
    }, 1000);
  }


  ShowError(_title: string = '', _text: string = '') {
    Swal.fire({
      icon: 'info',
      title: _title,
      text: _text,
      allowOutsideClick: false,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      }
    });
  }


  //Utils

  ChangeAllData(item: DrawAllMapInterface) {
    this.DrawAllData.next({ Data: item });
  }
  DrawAllDataEvent(): Observable<any> {
    return this.DrawAllData.asObservable();
  }

  ChangeData(typeObject: number, id: number[], _put: boolean, _remove: boolean) {
    this.DrawData.next({ Data: this.GetDataToMap(typeObject, id, _put, _remove) });
  }
  DrawDataEvent(): Observable<any> {
    return this.DrawData.asObservable();
  }

  ChangeZoom(item: any) {
    this.ZoomData.next({ Data: item });
  }
  DrawZomm(): Observable<any> {
    return this.ZoomData.asObservable();
  }
}
